import { memo } from 'react';
import { LoaderSpinner } from '@components/loader-spinner';

import { getActiveState, getToggleCircleClass, getToggleContainerClass } from '../utils';

import { SwitchToggleProps } from './switch-toggle.type';
const SwitchToggle = ({
  active,
  loading,
  loadingColor,
  activeIcon,
  inactiveIcon,
  onToggleSwitch,
  disabled,
  reverseOperation,
  border,
  variant = 's',
}: SwitchToggleProps) => {
  const activeState = getActiveState(active, reverseOperation);
  const toggleContainerClass = getToggleContainerClass({ loading, activeState, variant, disabled });
  const toggleCircleClass = getToggleCircleClass({
    activeState,
    loading,
    loadingColor,
    border,
    variant,
  });

  const handleToggleClick = (e: React.KeyboardEvent | React.MouseEvent) => {
    if (loading) return;
    onToggleSwitch(!active, e);
  };

  return (
    <div
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      className={toggleContainerClass}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleToggleClick(e);
        }
      }}
      role='switch'
      tabIndex={0}
      onClick={handleToggleClick}
      aria-label={'Switch Toggle'}
      aria-checked={activeState}
      aria-disabled={loading || disabled}
      aria-busy={loading}>
      <div className={toggleCircleClass}>
        {loading && <LoaderSpinner dataTestId='spinner' />}
        {activeState && !loading && activeIcon && activeIcon}
        {!activeState && !loading && inactiveIcon && inactiveIcon}
      </div>
    </div>
  );
};

export default memo(SwitchToggle);
